var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
import { round } from '../../../../utils/helper/lodash_replacements';
export class TopicInfo {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    givenStars = 0;
    get topic() {
        return this.parent;
    }
    get relativeknowledge_distribution() {
        return this.topic.json_options.relativeknowledge_distribution || [];
    }
    get numberOfRatings() {
        return this.topic.maxRating / 5 + (!!this.givenStars ? 1 : 0);
    }
    get ratingQuotient() {
        return (this.topic.rating + this.givenStars) / (this.numberOfRatings * 5);
    }
    get ratingStars() {
        return round(5 * this.ratingQuotient, 1);
    }
}
__decorate([
    observable
], TopicInfo.prototype, "givenStars", void 0);
